export default {"src":"/_next/static/media/GalvanSquare.7b4186e9.svg","height":38,"width":119};